const dateFormatMixin = {
    methods: {
        convertDateBrToUs (data) {
            const dia  = data.split("/")[0];
            const mes  = data.split("/")[1];
            const ano  = data.split("/")[2];

            return ano + '-' + ("0"+mes).slice(-2) + '-' + ("0"+dia).slice(-2);
        },
        convertDateUsToBr (data) {
            var ano  = data.split("-")[0];
            var mes  = data.split("-")[1];
            var dia  = data.split("-")[2];

            return dia.slice(-2) + '/' + ("0"+mes).slice(-2) + '/' + ano;
        }
    }
}

export default dateFormatMixin
